import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatIndianNumber } from "../utiles/FormatIndianNumber";
import TableLayout from "./TableLayout";
import useLocale from "../locales";
import { setFilterInvestmentData } from "../redux/calculations/slice";  
import { useDispatch } from "react-redux";

const SipTable = ({ showTable }) => {
  const dispatch = useDispatch();
  const [reportData, setReportData] = useState([]);
  const {textData} = useLocale();
  const {
    age,
    monthlyInvestment,
    incrementPerYear,
    approxReturn,
    noOfInvestementYear,
    swpStartYear,
    yearlyWithdraw,
    yearlyIncrementInWithdrawSwp,
    investmentDataSIP,
    investmentAmounts,
    filterInvestmentData
  } = useSelector((state) => state.sip);

  const freeAmount = useSelector((state) => state.sip.freeAmount || 0);

  useEffect(() => {
    if (
      showTable &&
      age &&
      monthlyInvestment &&
      incrementPerYear &&
      approxReturn &&
      noOfInvestementYear
    ) {
      generateReportData();
    }
  }, [showTable, age, monthlyInvestment, incrementPerYear, approxReturn, noOfInvestementYear, swpStartYear, yearlyWithdraw, yearlyIncrementInWithdrawSwp,investmentAmounts,freeAmount]);

  const generateReportData = () => {
    const initialAge = Number(age);
    const initialMonthlyInvestment = Number(monthlyInvestment.toString().replace(/,/g, ""));
    const yearlyIncrement = Number(incrementPerYear) / 100;
    const yearlyReturn = Number(approxReturn) / 100;
    const investmentYears = Number(noOfInvestementYear);
    const swpStart = Number(swpStartYear);
    const initialYearlyWithdraw = Number(yearlyWithdraw.toString().replace(/,/g, ""));
    const withdrawalIncrement = Number(yearlyIncrementInWithdrawSwp) / 100;

    let data = [];
    let currentAge = initialAge;
    let currentMonthlyInvestment = initialMonthlyInvestment;
    let totalInvestment = 0;
    let totalBalance = 0;

    for (let year = 1; year <= investmentYears; year++) {
      const yearlyInvestment = currentMonthlyInvestment * 12;
      totalInvestment += yearlyInvestment;

      let freeAmountAdded = 0;
      if (investmentAmounts && investmentAmounts[year - 1]) {
        const amountValue = typeof investmentAmounts[year - 1] === 'string' 
          ? investmentAmounts[year - 1].replace(/,/g, "") 
          : investmentAmounts[year - 1];
        
        freeAmountAdded = Number(amountValue);
        
        if (freeAmountAdded > 0) {
          totalInvestment += freeAmountAdded;
        }
      }

      const yearlyGrowth = (totalBalance + yearlyInvestment + freeAmountAdded) * yearlyReturn;
      totalBalance = totalBalance + yearlyInvestment + freeAmountAdded + yearlyGrowth;

      let swpAmount = 0;
      let returnAfterSWP = totalBalance;
      let monthlyReturn = 0;

      if (currentAge >= initialAge + swpStart) {
        const yearsInSWP = currentAge - (initialAge + swpStart) + 1;
        swpAmount = initialYearlyWithdraw * Math.pow(1 + withdrawalIncrement, yearsInSWP - 1);
        
        returnAfterSWP = totalBalance - swpAmount;
        monthlyReturn = swpAmount / 12;
        
        totalBalance = returnAfterSWP;
      }

      data.push({
        age: currentAge,
        year: year,
        monthlyInstallment: currentMonthlyInvestment,
        freeAmountAdded: freeAmountAdded > 0 ? freeAmountAdded : "-",
        yearlyInvestment: yearlyInvestment + freeAmountAdded,
        yearlyReturn: totalBalance,
        swp: swpAmount || "-",
        returnAfterSWP: returnAfterSWP,
        monthlyReturn: monthlyReturn || "-"
      });

      currentAge++;
      currentMonthlyInvestment = currentMonthlyInvestment * (1 + yearlyIncrement);
    }
    
    setReportData(data);
    // dispatch(setFilterInvestmentData(data));

  };

  const columns = [
    { key: 'age', label: textData.tableLabels.age, format: (value) => value },
    { key: 'year', label: textData.tableLabels.year, format: (value) => value },
    { 
      key: 'monthlyInvestment', 
      label: `${textData.tableLabels.monthlyInvestment}  (${textData.currency})`, 
      format: (value) => !value ? "-" : `${FormatIndianNumber(Math.round(value))}` 
    },
    { 
      key: 'investmentAmounts', 
      label: `${textData.tableLabels.additionalInvestment} (${textData.currency})`, 
      format: (value) => !value ? "-" : `${FormatIndianNumber(Math.round(value))}`
    },
    { 
      key: 'yearlyInvestment', 
      label: `${textData.tableLabels.totalInvestment} (${textData.currency})`, 
      format: (value) => !value ? "-" : `${FormatIndianNumber(Math.round(value))}`
    },
    { 
      key: 'yearlyReturn', 
      label: `${textData.tableLabels.yearlyReturn} (${textData.currency})`, 
      format: (value) => `${FormatIndianNumber(Math.round(value))}`
    },
    { 
      key: 'swpAmount', 
      label: `${textData.tableLabels.swpAmount} (${textData.currency})`, 
      format: (value) => !value ? "-" : `${FormatIndianNumber(Math.round(value))}`
    },
    { 
      key: 'yearlyReturnAfterSWP', 
      label: `${textData.tableLabels.returnAfterSWP} (${textData.currency})`, 
      format: (value) => `${FormatIndianNumber(Math.round(value))}`
    },
    { 
      key: 'monthlyReturn', 
      label: `${textData.tableLabels.monthReturn} (${textData.currency})`, 
      format: (value) => !value ? "-" : `${FormatIndianNumber(Math.round(value))}`
    },
    { 
      key: 'ltcgAmount', 
      label: `${textData.tableLabels.ltcgAmount} (${textData.currency})`, 
      format: (value) => !value ? "-" : `${FormatIndianNumber(Math.round(value))}`
    }
  ];

  return (
    <TableLayout
      showTable={showTable}
      title={`${textData.filterDropDown.sipCalc} ${textData.report}`}
      data={filterInvestmentData}
      columns={columns}
      analyticsEventName="download_sip_swp_report"
      reportTitle={textData.reportTitle.sipReport}
      fileName="sip_swp_detail"
    />
  );
};

export default SipTable;